// channel-status.ts — (tf3-34b; Part B §3, §7.9) the words Settings shows for a connected channel, pure: when it needs its
// owner to connect again (a refused grant, a token that expired, an Instagram channel from before Instagram Login), and
// what a Disconnect did — revoked at the platform (YouTube, TikTok), or, for Instagram (no revoke call), what the person
// still does themselves.
export type Platform = "YouTube" | "TikTok" | "Instagram";
const NEEDS_RECONNECT = new Set(["needs_reconnect", "expired"]);

/** Pure: the reconnect prompt for a channel, or null when it works. The package's own reason when it gave one. */
export function reconnectPrompt(ch: { status?: string | null; statusReason?: string | null }): string | null {
  if (!ch.status || !NEEDS_RECONNECT.has(ch.status)) return null;
  return ch.statusReason?.trim() || "This connection stopped working: reconnect it to keep posting.";
}

/** Pure: what a Disconnect did, in words (the backend answers the package's { revoked, revokeError }). */
export function disconnectWords(platform: Platform, r: { revoked?: boolean; revokeError?: string | null }): string {
  if (platform === "Instagram")
    return "Disconnected: the tokens are erased and the data we kept is deleted. Instagram has no way for us to revoke access, so also remove TubeForge in Instagram (Settings → Apps and websites).";
  if (r.revoked) return `Disconnected: ${platform}'s access is revoked, the tokens are erased and the data we kept is deleted.`;
  return `Disconnected: the tokens are erased and the data we kept is deleted, but ${platform} didn't confirm the revoke, so also remove TubeForge in ${platform}'s own settings.`;
}
